import { ThemeObservable, UserHelper } from '@hub/shared'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import { SubscriptionLike } from 'rxjs'
import './wake-products.page.scoped.scss'

const WakeProductsPageComponent = (props: any) => {
  const userHelper = useMemo(() => new UserHelper(), [])
  const [token, setToken] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [theme, setTheme] = useState<string>('light')
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [campaignId, setCampaignId] = useState<string | null>(null)

  useEffect(() => {
    userHelper.getUserObject().then((user) => {
      if (user.JWT) {
        setToken(user.JWT)
        setLoading(false)
      } else {
        navigate('/login')
      }
    })

    const onThemeChangeSubscription: SubscriptionLike = ThemeObservable.subscribe((theme) => {
      setTheme(theme)
    })

    return () => {
      onThemeChangeSubscription?.unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userHelper])

  useEffect(() => {
    setCampaignId(searchParams?.get('campaign'))
  }, [searchParams])

  if (loading || !token) {
    return null
  }

  return (
    <div className="wake-products-page box">
      <iframe
        src={`${props.environments.wakeInovationListProductsUrl}?token=${encodeURI(token)}&theme=${theme}${
          campaignId ? `&campaign=${campaignId}` : ''
        }`}
        title="Wakeshop"
        className="wake-products-page-iframe scrollbar"
      />
    </div>
  )
}
export default WakeProductsPageComponent
